import { path } from 'Utility/ramdaReplacement';

export type TFunctionalPerformanceDocumentType = SafeExtract<
  TDocumentType,
  | 'uhdrsFunctionalAssessment'
  | 'uhdrsIndependenceScale'
  | 'uhdrsFunctionalCapacity'
  | 'modifiedRankinScale'
  | 'modifiedChildrensGlobalAssessmentScale'
>;

const docType = (
  documents: Array<IDocumentWithTypeV2<TFunctionalPerformanceDocumentType>>,
  editing: string | undefined,
): string | undefined =>
  editing
    ? path(
        ['_type'],
        documents.find(d => d._id === editing),
      )
    : undefined;

export const getHeaderId = (
  documents: Array<IDocumentWithTypeV2<TFunctionalPerformanceDocumentType>>,
  editing?: string,
  viewing?: string,
): string => {
  if (!editing && !viewing) return 'functionalPerformance.title';
  // handle both editing and viewing modes
  const docId = editing ?? viewing;
  // if the user is in editing or viewing mode and docType returns the doctype, return correct title for the header
  if (docType(documents, docId)) {
    return `functionalPerformance.${docType(documents, docId)}`;
  }
  return 'functionalPerformance.title';
};
